import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartColumn } from "@fortawesome/free-solid-svg-icons";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import i18n from "../../i18n";

type DashboardCardEmptyStateProps = {
  isFullScreen?: boolean;
  icon?: IconDefinition;
  title?: string;
  subtitle?: string;
};

export const DashboardCardEmptyState: React.FC<DashboardCardEmptyStateProps> = ({
  isFullScreen,
  icon = faChartColumn,
  title = i18n.t("frame.noDataTitle", { ns: "dashboard" }),
  subtitle = i18n.t("frame.noDataSubtitle", { ns: "dashboard" }),
}) => (
  <div className="animate-fade-in h-full w-full flex flex-col items-center justify-center gap-3 px-6 py-10 text-center text-theme-text-muted group">
    <div
      className={`flex items-center justify-center rounded-full border border-theme-border group-hover:shadow-[0_0_10px_2px_var(--theme-info)] group-hover:border-theme-info group-hover:translate-y-[-1px] transition bg-theme-surface ${
        isFullScreen ? "h-28 w-28" : "h-20 w-20"
      }`}
    >
      <FontAwesomeIcon
        icon={icon}
        className={`text-theme-text-muted group-hover:text-theme-info-hover transition-colors  ${isFullScreen ? "text-5xl" : "text-3xl"}`}
      />
    </div>
    <p className={`font-semibold text-theme-text transition-all ${isFullScreen ? "text-3xl" : "text-xl"}`}>
      {title}
    </p>
    <p className={`max-w-[28rem] ${isFullScreen ? "text-lg" : "text-sm"}`}>{subtitle}</p>
  </div>
);
